import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const AdminSubPage = ({ title, breadcrumb, backPath, actionLabel, onAction, children }) => {
  const navigate = useNavigate();
  return (
    <div className="space-y-6 fade-in" data-testid={`page-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center gap-2 text-xs text-gray-500 mb-1">
        {breadcrumb.map((b, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span>/</span>}
            <span className={i === breadcrumb.length - 1 ? 'text-[#1f1f1f] font-medium' : ''}>{b}</span>
          </React.Fragment>
        ))}
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {backPath && (
            <Button variant="ghost" size="sm" onClick={() => navigate(backPath)} className="text-gray-500 hover:text-[#1f1f1f] -ml-2">
              <ArrowLeft className="w-4 h-4" />
            </Button>
          )}
          <h1 className="font-display text-2xl font-bold text-[#1f1f1f]">{title}</h1>
        </div>
        {actionLabel && onAction && (
          <Button onClick={onAction} className="bg-[#1f1f1f] hover:bg-[#333333] text-white" data-testid="page-action-btn">
            {actionLabel}
          </Button>
        )}
      </div>
      {children}
    </div>
  );
};

export default AdminSubPage;
